<avi-dashboard-widget
    class="threat-intelligence-widget"
    shape="lightbulb"
    status="success"
    [iconSize]="24"
    headerText="{{ l10nKeys.threatIntelligenceHeader | vtranslate }}"
>
    <div
        dashboardWidgetBody
        class="threat-intelligence-widget__body"
    >
        <ng-container *ngrxLet="pulseWafManagementStatus$ as pulseWafManagementStatus">
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.cloudServicesWafManagementLabel | vtranslate }}
            </span>
            <div
                class="threat-intelligence-widget__value sel-portal-url"
                [ngClass]="pulseWafManagementStatus ? 'threat-intelligence-widget__enabled' : 'threat-intelligence-widget__deactivated'"
            >
                {{ (pulseWafManagementStatus ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
            </div>
        </ng-container>

        <div class="threat-intelligence-widget__value-container">
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.signaturesLabel | vtranslate }}
            </span>
        </div>

        <div
            class="threat-intelligence-widget__value-container"
            *ngrxLet="wafSignaturesNotificationsStatus$ as wafSignaturesNotificationsStatus"
        >
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.receiveNotificationsLabel | vtranslate }}
            </span>
            <div
                class="threat-intelligence-widget__value sel-portal-url"
                [ngClass]="wafSignaturesNotificationsStatus ? 'threat-intelligence-widget__enabled' : 'threat-intelligence-widget__deactivated'"
            >
                {{ (wafSignaturesNotificationsStatus ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
            </div>
        </div>

        <div
            class="threat-intelligence-widget__value-container"
            *ngrxLet="autoDownloadWafSignaturesStatus$ as autoDownloadWafSignaturesStatus"
        >
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.autoDownloadWafSignaturesLabel | vtranslate }}
            </span>
            <div
                class="threat-intelligence-widget__value sel-portal-url"
                [ngClass]="autoDownloadWafSignaturesStatus ? 'threat-intelligence-widget__enabled' : 'threat-intelligence-widget__deactivated'"
            >
                {{ (autoDownloadWafSignaturesStatus ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
            </div>
        </div>

        <div class="threat-intelligence-widget__value-container">
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.applicationRulesLabel | vtranslate }}
            </span>
        </div>

        <div
            class="threat-intelligence-widget__value-container"
            *ngrxLet="appSignatureSyncStatus$ as appSignatureSyncStatus"
        >
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.autoSyncApplicationRulesDbUpdatesLabel | vtranslate }}
            </span>
            <div
                class="threat-intelligence-widget__value sel-portal-url"
                [ngClass]="appSignatureSyncStatus ? 'threat-intelligence-widget__enabled' : 'threat-intelligence-widget__deactivated'"
            >
                {{ (appSignatureSyncStatus ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
            </div>
        </div>

        <div
            class="threat-intelligence-widget__value-container"
            *ngrxLet="ipReputationStatus$ as ipReputationStatus"
        >
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.autoSyncIpReputationDbUpdatesLabel | vtranslate }}
            </span>
            <div
                class="threat-intelligence-widget__value sel-portal-url"
                [ngClass]="ipReputationStatus ? 'threat-intelligence-widget__enabled' : 'threat-intelligence-widget__deactivated'"
            >
                {{ (ipReputationStatus ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
            </div>
        </div>

        <div
            class="threat-intelligence-widget__value-container"
            *ngrxLet="userAgentDbSyncStatus$ as userAgentDbSyncStatus"
        >
            <span class="threat-intelligence-widget__label">
                {{ l10nKeys.userAgentDbSyncLabel | vtranslate }}
            </span>
            <div
                class="threat-intelligence-widget__value sel-portal-url"
                [ngClass]="userAgentDbSyncStatus ? 'threat-intelligence-widget__enabled' : 'threat-intelligence-widget__deactivated'"
            >
                {{ (userAgentDbSyncStatus ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
            </div>
        </div>
    </div>
</avi-dashboard-widget>
